var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchHomeIcon = function SvgSearchHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M37.97 16.628a14.946 14.946 0 0 1-2.925 9.934c-.964 1.294-1.909 2.595-2.767 3.956l-6.492 10.313c-1.248 1.987-4.144 1.987-5.396 0l-5.475-8.7c-1.095-1.74-2.246-3.446-3.544-5.036A14.915 14.915 0 0 1 8 17.626C8 8.982 15.313 2.045 24.087 2.663c7.418.525 13.4 6.548 13.883 13.965ZM23 27.002a9.375 9.375 0 1 0 0-18.75A9.375 9.375 0 1 0 23 27Z"
  })));
};
export default SvgSearchHomeIcon;